export default __webpack_public_path__ + "static/media/challengeAirline.4d8ef439.png";